import './LeftNewsSection.scss'

import { Box, Heading, SkeletonText, Text, VStack } from '@chakra-ui/react'
import { t } from 'i18next'
import { useAtomValue } from 'jotai'

import useColorModeValue from '@/hooks/useColorModeValue'
import { loadingAtom, selectedNewsAtom } from '@/store/news'
import { INewsItem } from '@/types/news'

import NewsMarkdownRenderer from '../util'

export default function LeftNewsSection() {
    const selectedNews: INewsItem = useAtomValue(selectedNewsAtom)
    const loading = useAtomValue(loadingAtom)
    const color = useColorModeValue('var(--chakra-colors-blue-900)', 'var(--chakra-colors-white)')
    const publishedDateColor = useColorModeValue('var(--chakra-colors-blue-500)', 'var(--chakra-colors-white)')
    const bgColor = useColorModeValue('var(--chakra-colors-gray-100)', 'var(--chakra-colors-dark-100)')
    return (
        <Box flex="1.5" alignItems="flex-start">
            <Box mx="auto">
                <Heading fontSize="md" fontWeight="700" mb={4} color={color}>
                    {t('news.mainNews.heading')}
                </Heading>
                {selectedNews.title ? (
                    <>
                        <VStack align="start" border="1px solid" borderColor="gray.200" borderRadius="md" maxH="100vh" overflowY="auto">
                            <Heading as="h1" size="3xl" px={4} pt={6}>
                                {selectedNews.title}
                            </Heading>
                            <Text px={4} className="leftNewsSection-Subtitle">
                                {selectedNews.subtitle}
                            </Text>
                            <Text fontSize="sm" color={publishedDateColor} px={4} py={1}>
                                {selectedNews.publishDate &&
                                    new Date(selectedNews.publishDate)
                                        .toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
                                        .replace(/ (\w+) /, (_, m) => ' ' + m.toUpperCase() + ' ')}
                            </Text>
                            <Box px={4} bg={bgColor} width="100%" className="leftNewsSection-intro">
                                <NewsMarkdownRenderer text={selectedNews.introduction} />
                            </Box>
                            <Box px={4} fontSize="md" className="leftNewsSection-Subtitle">
                                <NewsMarkdownRenderer text={selectedNews.article} />
                            </Box>
                        </VStack>
                    </>
                ) : (
                    loading && <SkeletonText noOfLines={6} />
                )}
            </Box>
        </Box>
    )
}
